{
  "name": "mft-web",
  "version": "21.0.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "install schematics": "echo 'Installalo manualmente con `npm install @angular-devkit/schematics-cli` perché Daniele ha problemi con Volta 🙄'",
    "stringifier": "schematics ./schematics/stringifier:stringifier --debug=false",
    "download_types": "pwsh ./download_types.ps1",
    "start": "npm run download_types && ng serve --host 0.0.0.0",
    "build": "ng build --aot --optimization -c production",
    "build dev": "ng build --aot --optimization -c development",
    "serve-dist": "serve -s dist/mft-web/browser -l 4200",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.1",
    "@angular/cdk": "^21.2.1",
    "@angular/common": "^21.2.1",
    "@angular/compiler": "^21.2.1",
    "@angular/core": "^21.2.1",
    "@angular/forms": "^21.2.1",
    "@angular/platform-browser": "^21.2.1",
    "@angular/platform-browser-dynamic": "^21.2.1",
    "@angular/router": "^21.2.1",
    "@microsoft/signalr": "^10.0.0",
    "@fullcalendar/core": "^6.1.20",
    "@ngneat/until-destroy": "^10.0.0",
    "ace-builds": "^1.43.6",
    "angularx-qrcode": "^21.0.5",
    "async-mutex": "^0.5.0",
    "chart.js": "^4.5.1",
    "chartjs-adapter-date-fns": "^3.0.0",
    "class-transformer": "^0.5.1",
    "date-fns": "^4.1.0",
    "date-fns-tz": "^3.2.0",
    "jwt-decode": "^4.0.0",
    "konva": "^10.2.3",
    "ngx-highlightjs": "^14.0.1",
    "primeflex": "4.0.0",
    "primeicons": "7.0.0",
    "primeng": "^21.1.3",
    "@primeuix/themes": "^2.0.3",
    "quill": "^2.0.3",
    "reflect-metadata": "^0.2.2",
    "rxjs": "^7.8.2",
    "ts-retrofit": "^1.19.1",
    "tsc-progress": "^1.0.4",
    "tslib": "^2.8.1",
    "web-animations-js": "^2.3.2",
    "zone.js": "^0.16.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.1",
    "@angular/cli": "^21.2.1",
    "@angular/compiler-cli": "^21.2.1",
    "@angular/language-service": "^21.2.1",
    "@angular/localize": "^21.2.1",
    "@fortawesome/fontawesome-free": "^7.2.0",
    "@types/node": "~15.6.1",
    "codelyzer": "^6.0.2",
    "ts-node": "~10.0.0",
    "tslint": "~6.1.3",
    "typescript": "5.9.3",
    "serve": "^14.2.6"
  },
  "volta": {
    "node": "22.12.0"
  }
}
